import React from "react"
import {useTranslation} from "react-i18next"
import {Dialog, DialogContent, Typography} from "@mui/material"
import {ReactComponent as ClosedSign} from "../../icon/closed-sign.svg"
import ClosedGraphic from "../common/ClosedGraphic"
import {Gallery} from "../../library/Gallery"
import BlueButton from "../buttons/BlueButton"

interface ClosedModalProps {
  show: boolean
  gallery: Gallery
}

export default function ClosedModal({show, gallery}: ClosedModalProps) {
  const {t} = useTranslation()

  return (
    <Dialog
      open={show}
      disableEscapeKeyDown
      slotProps={{paper: {sx: {borderRadius: "0.7rem", color: "#323232", maxWidth: 480}}}}
    >
      <DialogContent sx={{p: 4, textAlign: "center"}}>
        <ClosedGraphic
          horizontalOffset="-85px"
          verticalOffset="-70px"
        >
          <ClosedSign/>
        </ClosedGraphic>
        <Typography fontSize={28} fontWeight={500}>{t("closed.heading")}</Typography>
        <Typography fontSize={18} fontWeight={400} sx={{mt: 1}}>
          {t("closed.text")}
        </Typography>
        {gallery && gallery.totalUploads > 0 && gallery.privacy === "public" && (
          <BlueButton
            href={gallery.url}
            sx={{mt: 2}}
          >
            {t("closed.viewGallery")}
          </BlueButton>
        )}
      </DialogContent>
    </Dialog>
  )
}
